export default __webpack_public_path__ + "static/media/06-BB-(1-1).89b998ab.jpg";